// source: itrdrmsgs_common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var singlegeneralorderhandling_pb = require('./singlegeneralorderhandling_pb.js');
goog.object.extend(proto, singlegeneralorderhandling_pb);
goog.exportSymbol('proto.it_grpc.FinxAiSequenceNumberRequest', null, global);
goog.exportSymbol('proto.it_grpc.FinxAiSequenceNumberResponse', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrCollectionMembership', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrMessageStatus', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrRPCReturnType', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrSearchCriteria', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrStipulations', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrStipulations.ValueCase', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrStreamMsgRequest', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrUUID', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrVoidMsgType', null, global);
goog.exportSymbol('proto.it_grpc.InstrumentSaveAction', null, global);
goog.exportSymbol('proto.it_grpc.ItrdrInstrumentSubTypeEnum', null, global);
goog.exportSymbol('proto.it_grpc.ItrdrInstrumentTypeEnum', null, global);
goog.exportSymbol('proto.it_grpc.LinkObjects', null, global);
goog.exportSymbol('proto.it_grpc.MsgStatus', null, global);
goog.exportSymbol('proto.it_grpc.ObjectId', null, global);
goog.exportSymbol('proto.it_grpc.SalesTicketSaveAction', null, global);
goog.exportSymbol('proto.it_grpc.TemplateCategoryEnum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrUUID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrUUID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrUUID.displayName = 'proto.it_grpc.ITrdrUUID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrVoidMsgType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrVoidMsgType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrVoidMsgType.displayName = 'proto.it_grpc.ITrdrVoidMsgType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.FinxAiSequenceNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.FinxAiSequenceNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.FinxAiSequenceNumberRequest.displayName = 'proto.it_grpc.FinxAiSequenceNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.FinxAiSequenceNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.FinxAiSequenceNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.FinxAiSequenceNumberResponse.displayName = 'proto.it_grpc.FinxAiSequenceNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrRPCReturnType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrRPCReturnType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrRPCReturnType.displayName = 'proto.it_grpc.ITrdrRPCReturnType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrCollectionMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrCollectionMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrCollectionMembership.displayName = 'proto.it_grpc.ITrdrCollectionMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrSearchCriteria = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrSearchCriteria, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrSearchCriteria.displayName = 'proto.it_grpc.ITrdrSearchCriteria';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ObjectId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ObjectId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ObjectId.displayName = 'proto.it_grpc.ObjectId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrMessageStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrMessageStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrMessageStatus.displayName = 'proto.it_grpc.ITrdrMessageStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.LinkObjects = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.LinkObjects.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.LinkObjects, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.LinkObjects.displayName = 'proto.it_grpc.LinkObjects';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrStreamMsgRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrStreamMsgRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrStreamMsgRequest.displayName = 'proto.it_grpc.ITrdrStreamMsgRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrStipulations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.it_grpc.ITrdrStipulations.oneofGroups_);
};
goog.inherits(proto.it_grpc.ITrdrStipulations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrStipulations.displayName = 'proto.it_grpc.ITrdrStipulations';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrUUID.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrUUID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrUUID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUUID.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    revision: jspb.Message.getFieldWithDefault(msg, 2, 0),
    bwayTimestamp: (f = msg.getBwayTimestamp()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.ITrdrUUID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrUUID;
  return proto.it_grpc.ITrdrUUID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrUUID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.ITrdrUUID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setRevision(value);
      break;
    case 3:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBwayTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrUUID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrUUID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrUUID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrUUID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRevision();
  if (f !== 0) {
    writer.writeSfixed32(
      2,
      f
    );
  }
  f = message.getBwayTimestamp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrUUID.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrUUID} returns this
 */
proto.it_grpc.ITrdrUUID.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed32 revision = 2;
 * @return {number}
 */
proto.it_grpc.ITrdrUUID.prototype.getRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrUUID} returns this
 */
proto.it_grpc.ITrdrUUID.prototype.setRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional fix.Timestamp bway_timestamp = 3;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrUUID.prototype.getBwayTimestamp = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 3));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrUUID} returns this
*/
proto.it_grpc.ITrdrUUID.prototype.setBwayTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrUUID} returns this
 */
proto.it_grpc.ITrdrUUID.prototype.clearBwayTimestamp = function() {
  return this.setBwayTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrUUID.prototype.hasBwayTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrVoidMsgType.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrVoidMsgType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrVoidMsgType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrVoidMsgType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrVoidMsgType}
 */
proto.it_grpc.ITrdrVoidMsgType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrVoidMsgType;
  return proto.it_grpc.ITrdrVoidMsgType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrVoidMsgType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrVoidMsgType}
 */
proto.it_grpc.ITrdrVoidMsgType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrVoidMsgType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrVoidMsgType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrVoidMsgType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrVoidMsgType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.FinxAiSequenceNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.FinxAiSequenceNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.FinxAiSequenceNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.FinxAiSequenceNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sequenceName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.FinxAiSequenceNumberRequest}
 */
proto.it_grpc.FinxAiSequenceNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.FinxAiSequenceNumberRequest;
  return proto.it_grpc.FinxAiSequenceNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.FinxAiSequenceNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.FinxAiSequenceNumberRequest}
 */
proto.it_grpc.FinxAiSequenceNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSequenceName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.FinxAiSequenceNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.FinxAiSequenceNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.FinxAiSequenceNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.FinxAiSequenceNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSequenceName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string sequence_name = 1;
 * @return {string}
 */
proto.it_grpc.FinxAiSequenceNumberRequest.prototype.getSequenceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.FinxAiSequenceNumberRequest} returns this
 */
proto.it_grpc.FinxAiSequenceNumberRequest.prototype.setSequenceName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.FinxAiSequenceNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.FinxAiSequenceNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.FinxAiSequenceNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.FinxAiSequenceNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.FinxAiSequenceNumberResponse}
 */
proto.it_grpc.FinxAiSequenceNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.FinxAiSequenceNumberResponse;
  return proto.it_grpc.FinxAiSequenceNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.FinxAiSequenceNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.FinxAiSequenceNumberResponse}
 */
proto.it_grpc.FinxAiSequenceNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.FinxAiSequenceNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.FinxAiSequenceNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.FinxAiSequenceNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.FinxAiSequenceNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 sequence_number = 1;
 * @return {number}
 */
proto.it_grpc.FinxAiSequenceNumberResponse.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.FinxAiSequenceNumberResponse} returns this
 */
proto.it_grpc.FinxAiSequenceNumberResponse.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrRPCReturnType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrRPCReturnType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrRPCReturnType.toObject = function(includeInstance, msg) {
  var f, obj = {
    returnVal: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    msg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrRPCReturnType}
 */
proto.it_grpc.ITrdrRPCReturnType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrRPCReturnType;
  return proto.it_grpc.ITrdrRPCReturnType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrRPCReturnType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrRPCReturnType}
 */
proto.it_grpc.ITrdrRPCReturnType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReturnVal(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrRPCReturnType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrRPCReturnType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrRPCReturnType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReturnVal();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool return_val = 1;
 * @return {boolean}
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.getReturnVal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrRPCReturnType} returns this
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.setReturnVal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string msg = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrRPCReturnType} returns this
 */
proto.it_grpc.ITrdrRPCReturnType.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrCollectionMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrCollectionMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCollectionMembership.toObject = function(includeInstance, msg) {
  var f, obj = {
    dbCollectionName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    keyAttrib: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrCollectionMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrCollectionMembership;
  return proto.it_grpc.ITrdrCollectionMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrCollectionMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.ITrdrCollectionMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDbCollectionName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyAttrib(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrCollectionMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrCollectionMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrCollectionMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDbCollectionName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKeyAttrib();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string db_collection_name = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.getDbCollectionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCollectionMembership} returns this
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.setDbCollectionName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string key_attrib = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.getKeyAttrib = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrCollectionMembership} returns this
 */
proto.it_grpc.ITrdrCollectionMembership.prototype.setKeyAttrib = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrSearchCriteria.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrSearchCriteria.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrSearchCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSearchCriteria.toObject = function(includeInstance, msg) {
  var f, obj = {
    queryCriteria: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrSearchCriteria}
 */
proto.it_grpc.ITrdrSearchCriteria.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrSearchCriteria;
  return proto.it_grpc.ITrdrSearchCriteria.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrSearchCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrSearchCriteria}
 */
proto.it_grpc.ITrdrSearchCriteria.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueryCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrSearchCriteria.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrSearchCriteria.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrSearchCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrSearchCriteria.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQueryCriteria();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string query_criteria = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrSearchCriteria.prototype.getQueryCriteria = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrSearchCriteria} returns this
 */
proto.it_grpc.ITrdrSearchCriteria.prototype.setQueryCriteria = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ObjectId.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ObjectId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ObjectId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ObjectId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    changeTimestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    changeUser: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ObjectId}
 */
proto.it_grpc.ObjectId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ObjectId;
  return proto.it_grpc.ObjectId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ObjectId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ObjectId}
 */
proto.it_grpc.ObjectId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeTimestamp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangeUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ObjectId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ObjectId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ObjectId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ObjectId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getChangeTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getChangeUser();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.it_grpc.ObjectId.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ObjectId} returns this
 */
proto.it_grpc.ObjectId.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.it_grpc.ObjectId.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ObjectId} returns this
 */
proto.it_grpc.ObjectId.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 change_timestamp = 3;
 * @return {number}
 */
proto.it_grpc.ObjectId.prototype.getChangeTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ObjectId} returns this
 */
proto.it_grpc.ObjectId.prototype.setChangeTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string change_user = 4;
 * @return {string}
 */
proto.it_grpc.ObjectId.prototype.getChangeUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ObjectId} returns this
 */
proto.it_grpc.ObjectId.prototype.setChangeUser = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrMessageStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrMessageStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrMessageStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrMessageStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    source: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrMessageStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrMessageStatus;
  return proto.it_grpc.ITrdrMessageStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrMessageStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrMessageStatus}
 */
proto.it_grpc.ITrdrMessageStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.it_grpc.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrMessageStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrMessageStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrMessageStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrMessageStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional MsgStatus status = 1;
 * @return {!proto.it_grpc.MsgStatus}
 */
proto.it_grpc.ITrdrMessageStatus.prototype.getStatus = function() {
  return /** @type {!proto.it_grpc.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.it_grpc.MsgStatus} value
 * @return {!proto.it_grpc.ITrdrMessageStatus} returns this
 */
proto.it_grpc.ITrdrMessageStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string source = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrMessageStatus.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrMessageStatus} returns this
 */
proto.it_grpc.ITrdrMessageStatus.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.LinkObjects.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.LinkObjects.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.LinkObjects.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.LinkObjects} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.LinkObjects.toObject = function(includeInstance, msg) {
  var f, obj = {
    collectionType: (f = msg.getCollectionType()) && proto.it_grpc.ITrdrCollectionMembership.toObject(includeInstance, f),
    objectType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    keyAttribute: jspb.Message.getFieldWithDefault(msg, 3, ""),
    linkAttribsList: jspb.Message.toObjectList(msg.getLinkAttribsList(),
    proto.it_grpc.ObjectId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.LinkObjects}
 */
proto.it_grpc.LinkObjects.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.LinkObjects;
  return proto.it_grpc.LinkObjects.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.LinkObjects} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.LinkObjects}
 */
proto.it_grpc.LinkObjects.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.it_grpc.ITrdrCollectionMembership;
      reader.readMessage(value,proto.it_grpc.ITrdrCollectionMembership.deserializeBinaryFromReader);
      msg.setCollectionType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyAttribute(value);
      break;
    case 4:
      var value = new proto.it_grpc.ObjectId;
      reader.readMessage(value,proto.it_grpc.ObjectId.deserializeBinaryFromReader);
      msg.addLinkAttribs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.LinkObjects.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.LinkObjects.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.LinkObjects} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.LinkObjects.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCollectionType();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.it_grpc.ITrdrCollectionMembership.serializeBinaryToWriter
    );
  }
  f = message.getObjectType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKeyAttribute();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLinkAttribsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.it_grpc.ObjectId.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrCollectionMembership collection_type = 1;
 * @return {?proto.it_grpc.ITrdrCollectionMembership}
 */
proto.it_grpc.LinkObjects.prototype.getCollectionType = function() {
  return /** @type{?proto.it_grpc.ITrdrCollectionMembership} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrCollectionMembership, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrCollectionMembership|undefined} value
 * @return {!proto.it_grpc.LinkObjects} returns this
*/
proto.it_grpc.LinkObjects.prototype.setCollectionType = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.LinkObjects} returns this
 */
proto.it_grpc.LinkObjects.prototype.clearCollectionType = function() {
  return this.setCollectionType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.LinkObjects.prototype.hasCollectionType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string object_type = 2;
 * @return {string}
 */
proto.it_grpc.LinkObjects.prototype.getObjectType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.LinkObjects} returns this
 */
proto.it_grpc.LinkObjects.prototype.setObjectType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string key_attribute = 3;
 * @return {string}
 */
proto.it_grpc.LinkObjects.prototype.getKeyAttribute = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.LinkObjects} returns this
 */
proto.it_grpc.LinkObjects.prototype.setKeyAttribute = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated ObjectId link_attribs = 4;
 * @return {!Array<!proto.it_grpc.ObjectId>}
 */
proto.it_grpc.LinkObjects.prototype.getLinkAttribsList = function() {
  return /** @type{!Array<!proto.it_grpc.ObjectId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ObjectId, 4));
};


/**
 * @param {!Array<!proto.it_grpc.ObjectId>} value
 * @return {!proto.it_grpc.LinkObjects} returns this
*/
proto.it_grpc.LinkObjects.prototype.setLinkAttribsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.it_grpc.ObjectId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ObjectId}
 */
proto.it_grpc.LinkObjects.prototype.addLinkAttribs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.it_grpc.ObjectId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.LinkObjects} returns this
 */
proto.it_grpc.LinkObjects.prototype.clearLinkAttribsList = function() {
  return this.setLinkAttribsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrStreamMsgRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrStreamMsgRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrStreamMsgRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    changeTimestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    clientId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrStreamMsgRequest}
 */
proto.it_grpc.ITrdrStreamMsgRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrStreamMsgRequest;
  return proto.it_grpc.ITrdrStreamMsgRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrStreamMsgRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrStreamMsgRequest}
 */
proto.it_grpc.ITrdrStreamMsgRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChangeTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrStreamMsgRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrStreamMsgRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrStreamMsgRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 change_timestamp = 1;
 * @return {number}
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.getChangeTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrStreamMsgRequest} returns this
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.setChangeTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrStreamMsgRequest} returns this
 */
proto.it_grpc.ITrdrStreamMsgRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.it_grpc.ITrdrStipulations.oneofGroups_ = [[2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.it_grpc.ITrdrStipulations.ValueCase = {
  VALUE_NOT_SET: 0,
  UINT32_VAL: 2,
  SINT32_VAL: 3,
  UINT64_VAL: 4,
  SINT64_VAL: 5,
  DECIMAL_VAL: 6,
  STRING_VAL: 7,
  BOOL_VAL: 8,
  SIDE: 9
};

/**
 * @return {proto.it_grpc.ITrdrStipulations.ValueCase}
 */
proto.it_grpc.ITrdrStipulations.prototype.getValueCase = function() {
  return /** @type {proto.it_grpc.ITrdrStipulations.ValueCase} */(jspb.Message.computeOneofCase(this, proto.it_grpc.ITrdrStipulations.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrStipulations.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrStipulations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrStipulations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrStipulations.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uint32Val: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sint32Val: jspb.Message.getFieldWithDefault(msg, 3, 0),
    uint64Val: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sint64Val: jspb.Message.getFieldWithDefault(msg, 5, 0),
    decimalVal: (f = msg.getDecimalVal()) && fix_pb.Decimal64.toObject(includeInstance, f),
    stringVal: jspb.Message.getFieldWithDefault(msg, 7, ""),
    boolVal: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    side: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrStipulations}
 */
proto.it_grpc.ITrdrStipulations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrStipulations;
  return proto.it_grpc.ITrdrStipulations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrStipulations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrStipulations}
 */
proto.it_grpc.ITrdrStipulations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setUint32Val(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSint32Val(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFixed64());
      msg.setUint64Val(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSint64Val(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDecimalVal(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStringVal(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoolVal(value);
      break;
    case 9:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrStipulations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrStipulations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrStipulations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrStipulations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFixed32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeSfixed32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFixed64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeSfixed64(
      5,
      f
    );
  }
  f = message.getDecimalVal();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.it_grpc.ITrdrStipulations.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional fixed32 uint32_val = 2;
 * @return {number}
 */
proto.it_grpc.ITrdrStipulations.prototype.getUint32Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setUint32Val = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearUint32Val = function() {
  return jspb.Message.setOneofField(this, 2, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasUint32Val = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional sfixed32 sint32_val = 3;
 * @return {number}
 */
proto.it_grpc.ITrdrStipulations.prototype.getSint32Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setSint32Val = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearSint32Val = function() {
  return jspb.Message.setOneofField(this, 3, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasSint32Val = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fixed64 uint64_val = 4;
 * @return {number}
 */
proto.it_grpc.ITrdrStipulations.prototype.getUint64Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setUint64Val = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearUint64Val = function() {
  return jspb.Message.setOneofField(this, 4, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasUint64Val = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sfixed64 sint64_val = 5;
 * @return {number}
 */
proto.it_grpc.ITrdrStipulations.prototype.getSint64Val = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setSint64Val = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearSint64Val = function() {
  return jspb.Message.setOneofField(this, 5, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasSint64Val = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 decimal_val = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrStipulations.prototype.getDecimalVal = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
*/
proto.it_grpc.ITrdrStipulations.prototype.setDecimalVal = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearDecimalVal = function() {
  return this.setDecimalVal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasDecimalVal = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string string_val = 7;
 * @return {string}
 */
proto.it_grpc.ITrdrStipulations.prototype.getStringVal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setStringVal = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearStringVal = function() {
  return jspb.Message.setOneofField(this, 7, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasStringVal = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool bool_val = 8;
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.getBoolVal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setBoolVal = function(value) {
  return jspb.Message.setOneofField(this, 8, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearBoolVal = function() {
  return jspb.Message.setOneofField(this, 8, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasBoolVal = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SingleGeneralOrderHandling.SideEnum side = 9;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.it_grpc.ITrdrStipulations.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.setSide = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.it_grpc.ITrdrStipulations} returns this
 */
proto.it_grpc.ITrdrStipulations.prototype.clearSide = function() {
  return jspb.Message.setOneofField(this, 9, proto.it_grpc.ITrdrStipulations.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrStipulations.prototype.hasSide = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * @enum {number}
 */
proto.it_grpc.MsgStatus = {
  OK: 0,
  NEW_ORDER_CREATE: 100,
  NEW_ORDER_RECVD_ROUTER: 101,
  NEW_ORDER_PERSISTED: 102,
  MANUAL_TRADE: 200,
  TRADE: 201,
  MANUAL_TRADE_AMEND: 202,
  MANUAL_TRADE_DELETE: 203,
  TRADE_ALLOCATED: 204,
  TRADE_ALLOCATION_BUST: 205,
  NEW_EXECUTION_RECVD: 206,
  NEW_EXECUTION_PERSISTED: 207,
  PRE_ALLOCATED: 208,
  ALLOCATION_CREATE: 500,
  ALLOCATION_SENT: 501,
  ALLOCATION_BUST: 502,
  ALLOCATED: 503,
  ALLOC_RECV_MSG_ROUTER: 504,
  ALLOC_PERSISTED: 505,
  ALLOC_SEND_READY: 506,
  ALLOCATION_SEND_FAILURE: 507,
  ALLOCATION_SAVE: 508,
  ALLOCATION_PROFILE_ACTIVE: 850,
  ALLOCATION_PROFILE_DELETED: 851,
  SALES_TICKET_SAVE: 860,
  SALES_TICKET_BUST: 861,
  TEMPLATE_SAVE: 870,
  GENERAL_FAILURE: 999
};

/**
 * @enum {number}
 */
proto.it_grpc.ItrdrInstrumentTypeEnum = {
  INSTRUMENT_TYPE_UNKNOWN: 0,
  INSTRUMENT_TYPE_FIXED_INCOME: 1,
  INSTRUMENT_TYPE_FUTURES: 2,
  INSTRUMENT_TYPE_REPO: 3,
  INSTRUMENT_TYPE_CUSTOM: 4
};

/**
 * @enum {number}
 */
proto.it_grpc.ItrdrInstrumentSubTypeEnum = {
  INSTRUMENT_SUB_TYPE_FI_BILL: 0,
  INSTRUMENT_SUB_TYPE_FI_NOTE: 1,
  INSTRUMENT_SUB_TYPE_FI_BOND: 2,
  INSTRUMENT_SUB_TYPE_FI_WI_BILL: 3,
  INSTRUMENT_SUB_TYPE_FI_WI_NOTE: 4,
  INSTRUMENT_SUB_TYPE_FI_WI_BOND: 5,
  INSTRUMENT_SUB_TYPE_FUTURES_EURIBOR: 6,
  INSTRUMENT_SUB_TYPE_FUTURES_EURIBOR_CAL_SPRD: 7,
  INSTRUMENT_SUB_TYPE_FUTURES_EURODOLLAR: 8,
  INSTRUMENT_SUB_TYPE_FUTURES_EURODOLLAR_CAL_SPRD: 9,
  INSTRUMENT_SUB_TYPE_FUTURES_EURODOLLAR_FLY: 10,
  INSTRUMENT_SUB_TYPE_FUTURES_EURODOLLAR_BUNDLE: 11,
  INSTRUMENT_SUB_TYPE_FUTURES_EURODOLLAR_PACK: 12,
  INSTRUMENT_SUB_TYPE_FUTURES_FEDFUND: 13,
  INSTRUMENT_SUB_TYPE_FUTURES_FEDFUND_CAL_SPRD: 14,
  INSTRUMENT_SUB_TYPE_FUTURES_FEDFUND_FLY: 15,
  INSTRUMENT_SUB_TYPE_FUTURES_FEDFUND_EDSPRD: 16,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS: 17,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS_CAL_SPRD: 18,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS_FLY: 19,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS_MICRO: 20,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS_MICRO_CAL_SPRD: 21,
  INSTRUMENT_SUB_TYPE_FUTURES_TREAS_TREAS_SPRD: 22,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR: 23,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_CAL_SPRD: 24,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_FLY: 25,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_BUNDLE: 26,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_ED_SPRD: 27,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_FF_SPRD: 28,
  INSTRUMENT_SUB_TYPE_FUTURES_SOFR_SOFR_SPRD: 29,
  INSTRUMENT_SUB_TYPE_FUTURES_INDEX: 30,
  INSTRUMENT_SUB_TYPE_FUTURES_INDEX_CAL_SPRD: 31,
  INSTRUMENT_SUB_TYPE_FUTURES_INDEX_FLY: 32,
  INSTRUMENT_SUB_TYPE_FUTURES_IRSWAP: 33,
  INSTRUMENT_SUB_TYPE_FUTURES_IRSWAP_CAL_SPRD: 34,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_GERMANY: 35,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_GERMANY_CAL_SPRD: 36,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_FRANCE: 37,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_FRANCE_CAL_SPRD: 38,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_ITALY: 39,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_ITALY_CAL_SPRD: 40,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_SPAIN: 41,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_SPAIN_CAL_SPRD: 42,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_SWITZERLAND: 43,
  INSTRUMENT_SUB_TYPE_FUTURES_GOVT_SWITZERLAND_CAL_SPRD: 44,
  INSTRUMENT_SUB_TYPE_REPO_GC_US_AGY: 45,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GC_STRIPS: 46,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GC_TIPS: 47,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GC_UST: 48,
  INSTRUMENT_SUB_TYPE_REPO_GCF_US_AGY: 49,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GCF_STRIPS: 50,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GCF_TIPS: 51,
  INSTRUMENT_SUB_TYPE_FUTURES_REPO_GCF_UST: 52,
  INSTRUMENT_SUB_TYPE_CUSTOM_SPREAD: 53
};

/**
 * @enum {number}
 */
proto.it_grpc.InstrumentSaveAction = {
  INSTRUMENT_SAVE_ACTION_NEW: 0,
  INSTRUMENT_SAVE_ACTION_UPDATE: 1,
  INSTRUMENT_SAVE_ACTION_DELETE: 2
};

/**
 * @enum {number}
 */
proto.it_grpc.SalesTicketSaveAction = {
  SALES_TICKET_SAVE_ACTION_NEW: 0,
  SALES_TICKET_SAVE_ACTION_UPDATE: 1
};

/**
 * @enum {number}
 */
proto.it_grpc.TemplateCategoryEnum = {
  TEMPLATE_SPREAD_DEF: 0,
  TEMPLATE_SPREAD_DEF_LEG: 1
};

goog.object.extend(exports, proto.it_grpc);
